module.exports = __webpack_public_path__ + "9ea5d08f9d24fd0ddadee2d5890d7299.png";